// extracted by mini-css-extract-plugin
export var bigListStyle = "shop-cart-summary-price-module--big-list-style--W4jUN";
export var bold = "shop-cart-summary-price-module--bold--C2vHp";
export var countHolder = "shop-cart-summary-price-module--count-holder--zfJwV";
export var countLine = "shop-cart-summary-price-module--count-line--FUwsh";
export var pink = "shop-cart-summary-price-module--pink--3vz-S";